import { render } from "./liuyan.vue?vue&type=template&id=2261395d"
import script from "./liuyan.vue?vue&type=script&lang=js"
export * from "./liuyan.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__